import { toast } from "react-toastify";

const showErrorSnackbar = (message) => {
	toast.error(message, {
		position: toast.POSITION.BOTTOM_RIGHT, 
		autoClose: 3000, // Set the duration for the snackbar
	});
};
export default showErrorSnackbar;
